// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"237776e7","239":"82fa3270","383":"655b58ae","453":"ecb6b6ff","624":"542f3b36","956":"272fbf82","970":"563a0e88"}[chunkId] + ".chunk.js";
};